<template>
  <a-modal title="选择工作中心" v-model="modalVisible" @ok="onConfirm" :confirmLoading="loading" destroyOnClose>
    <a-form-model ref="ruleFormRef" :model="materialForm" autoComplete="off" :wrapperCol="{ span: 19 }" :labelCol="{ span: 4 }">
      <a-form-model-item label="工作中心" :rules="[baseRequiredRule]" prop="workCenterCode">
        <global-select
          v-model="materialForm.workCenterCode"
          :focusGet="true"
          selectType="selectAssembleSearch"
          assembleLabel
          searchParam="centerName"
          :dropdown-match-select-width="false"
          requestApi="/bom/workCenter/list"
          :selectItem="{ value: 'centerCode', label: 'centerName' }"
          :setParams="{ organizationCode: detailData.organizationCode }"
          :totalNum="9999999999"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {
  apiRoutingLineCcWorkCenter
} from '@/api/mes/basedata/standardProcessNew'
export default {
  name: 'WorkSelectModal',
  components: {},
  props: {
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    this.baseRequiredRule = { required: true, message: ' ' }
    return {
      modalVisible: false,
      loading: false,
      materialForm: {}
    }
  },
  methods: {
    show() {
      this.modalVisible = true;
      this.materialForm = {};
    },
    onClose() {
      this.modalVisible = false;
    },
    onConfirm() {
      this.$refs.ruleFormRef.validate(valid => {
        if(valid) {
          this.loading = true;
          const { id: routingId } = this.detailData;
          apiRoutingLineCcWorkCenter({ routingId, ...this.materialForm }).then(res => {
            if(res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('successCall');
              this.onClose();
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
</style>
